import { Injectable } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

import { AddSpanModalComponent } from './add-span-modal.component';

@Injectable()
export class AddSpanModalService {

    constructor(private readonly dialog: MatDialog) { }

    showModal() {
        let dialogRef: MatDialogRef<AddSpanModalComponent>;

        dialogRef = this.dialog.open(
            AddSpanModalComponent,
            {
                height: '640px',
                disableClose: true,
            }
        );

        return dialogRef;
    }
}
